var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-layout":"aurora"}},[_c('aurora-wrapper',[_c('aurora-body',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }